import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'as-select-items',
  templateUrl: './select-items.component.html',
  styleUrls: ['./select-items.component.scss']
})
export class SelectItemsComponent implements OnInit {

  @Input() type: string;
  @Input() selectedItemsCount: number;
  @Input() tab: string;
  @Output() action = new EventEmitter();

  @ViewChild("deleteModal", {static: true}) deleteModal;
  @ViewChild("copyModal", {static: true}) copyModal;

  selectedItemsIndexes = [];
  selectedCount = 0;

  constructor() {
  }

  ngOnInit() {

  }

  //this component does not hold state for selected items. Use parent service for that

  buttonAction(action) {
    this.action.emit({index: this.selectedItemsIndexes, action: action});

    switch (action) {
      case 'delete' :
        this.deleteModal.hide();
        break;
      case 'copy' :
        this.copyModal.hide();
        break;
      case 'resend' :

        break;
      default:
         action
    }

  }

}
